export enum ProjectionMode {
  FLAT = "flat",
  SPHERE_EQUIRECTANGULAR = "360-equirectangular"
}
